import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './answer.css'

class Answer extends Component {

    render() {
        return (
            <div className="Answer">
                <span className="Answer__title">{'Řekněte nám, prosím víc:'}</span>
                <textarea
                    className="Answer__textarea"
                    onChange={this.props.onChange}
                    onBlur={this.props.onBlur}
                    value={this.props.text === null ? '' : this.props.text}
                />
            </div>
        );
    }

}

Answer.propTypes = {
    text: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
};

export default Answer;


// WEBPACK FOOTER //
// ./src/components/answer/index.js